/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { Button } from 'primereact/button';

type TabButtonProps = {
  icon: string;
  tooltip: string;
  active: boolean;
  actionProps?: any; // PrimeReact te lo da vía template options
  onClick?: () => void; // PrimeReact te lo da vía template options
};

export const TabButton = memo(function TabButton({
  icon,
  tooltip,
  active,
  actionProps,
  onClick,
}: TabButtonProps) {
  //Destructuring de actinosProps para separar className y resto de props
  const { className: extraClasses, ...restActionProps } = actionProps || {};
  //usa {} (un objeto vacío) para evitar errores al desestructurar.
  //tomo la propiedad className y la renombro a extraClasses para usarla después.

  const baseClasses =
    'w-full h-full flex items-center justify-center p-2 m-2 border-none bg-transparent';

  const activeClasses = ' text-teal-500 surface-100 shadow-2';
  const inactiveClasses = ' text-teal-400';

  const mergedClassName =
    baseClasses +
    (active ? activeClasses : inactiveClasses) +
    (extraClasses ? ` ${extraClasses}` : '');

  return (
    <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-full lg:aspect-square">
      <Button
        {...restActionProps}
        onClick={onClick}
        icon={icon}
        tooltip={tooltip}
        className={mergedClassName} // aquí usamos mergedClassName
        pt={{ icon: { className: 'text-3xl sm:text-4xl' } }}
        severity={active ? 'primary' : 'secondary'} // cambia color según active
        size="large"
        style={{ aspectRatio: '1' }}
        text
      />
    </div>
  );
});
